"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
var _breadcrumb = require("./breadcrumb.style");
const Breadcrumb = _ref => {
  let {
    mainObject,
    className = 'breadcrumb',
    separator = '/',
    activeItem = '',
    maxVisibleLength = 20,
    itemsBeforeCollapse,
    itemsAfterCollapse,
    isActiveItemClickable = false,
    onBreadcrumbClick
  } = _ref;
  const [breadcrumbArray, setBreadcrumbArray] = (0, _react.useState)([]);
  const toBeCollapsed = itemsAfterCollapse && itemsAfterCollapse > 0 || itemsBeforeCollapse && itemsBeforeCollapse > 0;
  const [isCollapsed, setIsCollapsed] = (0, _react.useState)(toBeCollapsed);
  (0, _react.useEffect)(() => {
    var _a;
    const breadcrumbLocator = ((_a = mainObject[activeItem]) === null || _a === void 0 ? void 0 : _a.breadcrumbLocator) || '';
    setBreadcrumbArray((breadcrumbLocator === null || breadcrumbLocator === void 0 ? void 0 : breadcrumbLocator.length) ? breadcrumbLocator.split('.') : []);
  }, [activeItem, mainObject]);
  const onClick = (item, itemKey) => {
    if (activeItem === itemKey && !isActiveItemClickable) {
      return;
    }
    if (typeof onBreadcrumbClick === 'function') {
      onBreadcrumbClick(item);
    } else {
      window.location.href = item.path;
    }
  };
  const handleInvalidInput = (itemsBefore, itemsAfter) => {
    if (itemsBefore !== undefined && itemsBefore < 1) {
      // eslint-disable-next-line no-console
      console.log("itemsBeforeCollapse can't be less than 1");
    } else if (itemsAfter !== undefined && itemsAfter < 1) {
      // eslint-disable-next-line no-console
      console.log("itemsAfterCollapse can't be less than 1");
    } else {
      // eslint-disable-next-line no-console
      console.log("itemsBeforeCollapse + itemsAfterCollapse can't be equal to or more than total items in BreadcrumbArray");
    }
  };
  const loadBreadcrumb = () => {
    const breadcrumbFragment = breadcrumbArray => {
      return (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
        children: breadcrumbArray && breadcrumbArray.map((item, index) => {
          var _a, _b, _c, _d, _e;
          return (0, _jsxRuntime.jsx)(_react.Fragment, {
            children: Object.prototype.hasOwnProperty.call(mainObject, item) && !mainObject[item].hidden && (0, _jsxRuntime.jsxs)(_breadcrumb.Components.Item, {
              children: [(0, _jsxRuntime.jsx)(_breadcrumb.Components.Title, (0, _extends2["default"])({
                className: "title",
                onClick: () => onClick(mainObject[item], item)
              }, {
                children: ((_b = (_a = mainObject[item]) === null || _a === void 0 ? void 0 : _a.label) === null || _b === void 0 ? void 0 : _b.length) > maxVisibleLength ? (0, _jsxRuntime.jsx)(_Tooltip["default"], (0, _extends2["default"])({
                  fit: "small",
                  content: (_c = mainObject[item]) === null || _c === void 0 ? void 0 : _c.label,
                  width: "auto",
                  position: "top",
                  appearance: "default"
                }, {
                  children: (0, _jsxRuntime.jsx)("span", {
                    children: ((_d = mainObject[item]) === null || _d === void 0 ? void 0 : _d.label.slice(0, maxVisibleLength)) + '...'
                  })
                })) : (0, _jsxRuntime.jsx)("span", (0, _extends2["default"])({
                  className: "isNotShortened"
                }, {
                  children: (_e = mainObject[item]) === null || _e === void 0 ? void 0 : _e.label
                }))
              })), (0, _jsxRuntime.jsx)(_breadcrumb.Components.Seperator, (0, _extends2["default"])({
                className: "seperator"
              }, {
                children: separator
              }))]
            })
          }, index);
        })
      });
    };
    const breadcrumbLen = breadcrumbArray === null || breadcrumbArray === void 0 ? void 0 : breadcrumbArray.length;
    const itemsNotCollapsed = (itemsBeforeCollapse || 0) + (itemsAfterCollapse || 0);
    if (!toBeCollapsed) {
      return breadcrumbFragment(breadcrumbArray);
    } else {
      if (itemsBeforeCollapse !== undefined && itemsBeforeCollapse < 1 || itemsAfterCollapse !== undefined && itemsAfterCollapse < 1 || itemsNotCollapsed >= breadcrumbLen) {
        handleInvalidInput(itemsBeforeCollapse, itemsAfterCollapse);
        return breadcrumbFragment(breadcrumbArray);
      }
      return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [breadcrumbFragment(breadcrumbArray.slice(0, itemsBeforeCollapse)), isCollapsed ? (0, _jsxRuntime.jsxs)("span", (0, _extends2["default"])({
          onClick: () => setIsCollapsed(!isCollapsed)
        }, {
          children: ['... ', (0, _jsxRuntime.jsx)(_breadcrumb.Components.Seperator, (0, _extends2["default"])({
            className: "seperator"
          }, {
            children: separator
          }))]
        })) : breadcrumbFragment(breadcrumbArray.slice(itemsBeforeCollapse, breadcrumbLen - (itemsAfterCollapse || 0))), breadcrumbFragment(breadcrumbArray.slice(breadcrumbLen - (itemsAfterCollapse || 0), breadcrumbLen))]
      });
    }
  };
  return (0, _jsxRuntime.jsx)(_breadcrumb.Components.Wrapper, (0, _extends2["default"])({
    className: className
  }, {
    children: loadBreadcrumb()
  }));
};
var _default = exports["default"] = Breadcrumb;